var MapboxInspect = require('./lib/MapboxInspect');
module.exports = MapboxInspect;



//////////////////
// WEBPACK FOOTER
// ./node_modules/mapbox-gl-inspect/index.js
// module id = 3bag
// module chunks = 7